import { render, staticRenderFns } from "./LmUploadFiles.vue?vue&type=template&id=b3d44b1c&scoped=true&"
import script from "./LmUploadFiles.vue?vue&type=script&lang=js&"
export * from "./LmUploadFiles.vue?vue&type=script&lang=js&"
import style0 from "./LmUploadFiles.vue?vue&type=style&index=0&id=b3d44b1c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d44b1c",
  null
  
)

export default component.exports